export enum ProfileMenuEnum {
	CHANGE_PLAN_OR_BENEFICIARY = 'alterar_plano_ou_beneficiario',
	MY_PROFILE = 'meu_perfil',
	HELP = 'ajuda',
	LOGOUT_BUTTON = 'logout',
	SOCIAL_NAME = 'nome_social',
	CANCELLED_CONTRACT = 'contrato_cancelado',
	SUSPENDED_CONTRACT = 'contrato_suspenso',
	FINANCIAL_RESPONSIBLE = 'responsavel_financeiro',
}
